import {AxiosError} from 'axios';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {ViewSubjectDetailResponse} from '../../api/candidate/exam/model';
import {GET_UNIQUE_LINK_SUBJECT_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import {GET_UNIQUE_LINK_SUBJECT_DETAILS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: ViewSubjectDetailResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  subjectCode: string;
}

export const useGetUniqueLinkSubjectDetails = ({onSuccess, onError, subjectCode}: Input) => {
  const getUniqueLinkSubjectDetails = async () => {
    const res = await axiosClient.get<ViewSubjectDetailResponse>(
        GET_UNIQUE_LINK_SUBJECT_DETAILS_URL(subjectCode)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_UNIQUE_LINK_SUBJECT_DETAILS_QUERY_KEY.concat(subjectCode),
      getUniqueLinkSubjectDetails,
      {
        onSuccess,
        onError,
        enabled: !!subjectCode,
      }
  );
};
